import { P } from '@ovotech/element-v5';
import { AnalyticsClick, useAnalytics } from '@ovotech/ui-tools';
import React, { useEffect } from 'react';
import { Media } from '@/src/components/Media';
import {
  DesktopContainer,
  HyundaiLeftContent,
  HyundaiMobileContainer,
  HyundaiRightContent,
} from './HyundaiAnytimeAppLink.styled';
import { breakpoints } from '@/src/utils/mediaQuery';
// TODO: Replace with Hyundai specific logo when available
import HYUNDAI_APP from '@/src/resources/hyundai-app.png';
import {
  HYUNDAI_CAR_APP_LINK,
  EV,
  useChargeAnytimeContext,
} from '@monovo/ev-anytime';
import { PageHeader } from '@/src/pages/AnytimeEligibilityV2/components/PageHeader';
import { PageWithNavigation } from '@/src/components';
import { PrimaryCTALink } from '@ovotech/nebula';
import { MobileOS, getDeviceOS } from '@/src/utils/getDeviceOS';

export const HyundaiAnytimeAppLink = () => {
  const { dispatch } = useAnalytics();
  const { integration } = useChargeAnytimeContext();

  const getHyundaiCarAppLink = () => {
    if (integration?.integrationType !== 'Hyundai') {
      return HYUNDAI_CAR_APP_LINK;
    }

    const { googlePlayStore, appleAppStore, webRedirect } =
      integration.integrationForwardUrl;
    const deviceOS = getDeviceOS();

    if (deviceOS === MobileOS.ANDROID && googlePlayStore) {
      return googlePlayStore;
    }

    if (deviceOS === MobileOS.IOS && appleAppStore) {
      return appleAppStore;
    }

    return webRedirect || HYUNDAI_CAR_APP_LINK;
  };

  const hyundaiCarAppLink = getHyundaiCarAppLink();
  useEffect(() => {
    dispatch({
      type: 'view',
      name: EV.ELIGIBILITY.EVS_OVO_CHARGE_ANYTIME_HYUNDAI_APP_VIEWED,
      properties: {
        Screen: EV.SCREENS.DOWNLOAD_HYUNDAI_APP,
        journeyName: 'Charge Anytime',
      },
    });
    // `dispatch` method is not memoized, and it causes useless calls.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({
      type: 'view',
      name: 'EVS - OVO Charge Anytime Hyundai app link viewed',
      properties: {
        Screen: EV.SCREENS.DOWNLOAD_HYUNDAI_APP,
        journeyName: 'Charge Anytime',
      },
    });
    // `dispatch` method is not memoized, and it causes useless calls.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWithNavigation title="Charge Anytime">
      <PageHeader
        data-testid="success-message"
        title={'Activate Charge Anytime'}
        showDescription={false}
      />
      <Media query={breakpoints.mediumUp}>
        <DesktopContainer>
          <HyundaiLeftContent>
            <img src={HYUNDAI_APP} alt="EV Anytime Hyundai App" />
          </HyundaiLeftContent>
          <HyundaiRightContent>
            <P>
              Now, just go back to your Hyundai app, link your account, and
              start charging!
            </P>
            <AnalyticsClick
              name={
                EV.ELIGIBILITY
                  .EVS_OVO_CHARGE_ANYTIME_HYUNDAI_CAR_APP_LINK_CLICKED
              }
            >
              <PrimaryCTALink
                data-event-name={
                  'EVS - EVS OVO Drive Anytime hyundai link clicked'
                }
                opensInNewWindow
                href={hyundaiCarAppLink}
              >
                Go to your Hyundai app
              </PrimaryCTALink>
            </AnalyticsClick>
          </HyundaiRightContent>
        </DesktopContainer>
      </Media>

      <Media query={breakpoints.mediumDown}>
        <HyundaiMobileContainer>
          <P>
            Now, just go back to your Hyundai app, link your account, and start
            charging!
          </P>
          <img src={HYUNDAI_APP} alt="EV Anytime Hyundai App" />
          <AnalyticsClick
            name={
              EV.ELIGIBILITY.EVS_OVO_CHARGE_ANYTIME_HYUNDAI_CAR_APP_LINK_CLICKED
            }
          >
            <PrimaryCTALink
              data-event-name={
                'EVS - EVS OVO Drive Anytime hyundai link clicked'
              }
              opensInNewWindow
              href={hyundaiCarAppLink}
            >
              Go to your Hyundai app
            </PrimaryCTALink>
          </AnalyticsClick>
        </HyundaiMobileContainer>
      </Media>
    </PageWithNavigation>
  );
};
